import { CSSProperties } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

import styles from "./pageLoader.module.scss";

export interface PageLoaderProps {
  style?: CSSProperties;
  text?: string;
}

function PageLoader(props: PageLoaderProps) {
  const { style, text } = props;

  return (
    <div style={style} className={styles.wrapper}>
      <CircularProgress size={64} />
      {text ? (
        <Box mt={4}>
          <Typography color='text.secondary' variant='body2'>
            {text}
          </Typography>
        </Box>
      ) : null}
    </div>
  );
}

export default PageLoader;
